import { Col, Row } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomSearch from '../../../v2-components/Antd/Search';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomTabs from '../../../v2-components/Antd/Tabs';
import CustomButton from '../../../v2-components/Antd/Button'
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';
import { Service } from '../service';
import { statusPreparation } from './constants/status.constant';
import { generateColumns } from './handle/generate-columns.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { tabOptions } from './handle/tab-options.handle';
import './style.scss';
import Loading from '../../../v2-components/Loading';
import { formatRut } from './handle/forma-rut.handle'

export default function QuotationListPage() {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [isTableLoading, setIsTableLoading] = useState(false);
	const history = useHistory();
	const location = useLocation();

	const searchParams = new URLSearchParams(location?.search);
	const page = searchParams.get('page');
	const statusQueryParam = searchParams.get('status');
	const [status, setStatus] = useState(statusQueryParam);
	const [paginationResponse, setPaginationResponse] = useState();
	const rowKey = '_id';
	const { pharmacy, token } = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const shortCodeQueryParam = searchParams.get('short_code');
	const rutQueryParam = searchParams.get('rut');
	const emailQueryParam = searchParams.get('email');
	const sortOrderQueryParam = searchParams.get('sortOrder');
	const [sortOrder, setSortOrder] = useState(sortOrderQueryParam || null); 
	const [shortCode, setShortCode] = useState(shortCodeQueryParam);
	const [rut, setRut] = useState(rutQueryParam);
	const [email, setEmail] = useState(emailQueryParam);
	const [isDownloading, setIsDownloading] = useState(false);

	console.log('statusqueryparam',statusQueryParam)

	const pagination = {
		currentPage: paginationResponse?.current_page,
		pageSize: paginationResponse?.items_per_page,
		totalItems: paginationResponse?.total_items,
	};


	useEffect(() => {
		const fetchData = async () => {
			let apiSortOrder = null;
			if (sortOrder === 'ascend') apiSortOrder = 'asc';
			if (sortOrder === 'descend') apiSortOrder = 'desc';
			setIsTableLoading(true);

			const baseParams = { status, page, pharmacy, short_code: shortCode, user_email: email, sortOrder: apiSortOrder };

			const extractList = (resp) => {
				if (!resp) return [];
				if (Array.isArray(resp)) return resp;
				if (resp.data && Array.isArray(resp.data)) return resp.data;
				return [];
			};

			try {
				// If there's a RUT filter, try both DV cases in parallel (backend handles punctuation)
				if (rut) {
					const raw = String(rut);
					const candidates = new Set([raw]);
					if (/[a-zA-Z]$/.test(raw)) {
						candidates.add(raw.slice(0, -1) + raw.slice(-1).toLowerCase());
						candidates.add(raw.slice(0, -1) + raw.slice(-1).toUpperCase());
					}

					const candidateArray = Array.from(candidates);
					const promises = candidateArray.map((candidate) =>
						new Service().getData({ ...baseParams, user_rut: candidate }).then((r) => ({ candidate, resp: r })).catch((error) => ({ candidate, error }))
					);

					const settled = await Promise.all(promises);
					const combinedList = [];
					settled.forEach((item) => {
						if (item && item.resp) {
							combinedList.push(...extractList(item.resp));
						}
					});

					if (combinedList.length > 0) {
						const map = new Map();
						combinedList.forEach((it) => {
							const id = it?.id || it?._id || it?.trx_id || it?.short_code || JSON.stringify(it);
							if (!map.has(id)) map.set(id, it);
						});
						const unique = Array.from(map.values());
						setData(unique);
						setPaginationResponse({ current_page: 1, items_per_page: unique.length, total_items: unique.length, data: unique });
						setIsTableLoading(false);
						setIsLoading(false);
						return;
					}
				}

				// Default single request (no RUT or nothing found with candidates)
				const response = await new Service().getData({ ...baseParams, user_rut: rut });
				setPaginationResponse(response);
				setData(response.data);
			} catch (error) {
				console.error('Error fetching data', error);
			} finally {
				setIsTableLoading(false);
				setIsLoading(false);
			}
		};

		fetchData();
	}, [status, page, pharmacy, shortCode, rut, email, sortOrder]);

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const onTabChange = () => {
		searchParams.set('page', 1);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleStatusQueryChange = (status) => {
		searchParams.set('status', status);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};
	const handleSearchCode = (short_code) => {
		const cleanCode = short_code ? short_code.trim() : '';
		if (cleanCode === '') {
			setShortCode(null);
			searchParams.delete('short_code');
			searchParams.set('page', 1);
		} else {
			setShortCode(short_code);
			searchParams.set('short_code', short_code);
			searchParams.set('page', 1);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	

	const handleDropdownSelect = (key) => {
		setStatus(key);
		handleStatusQueryChange(key);
	};


	const handleSearchRut = (rut) => {
		const cleanInput = rut ? rut.trim() : '';
		if (cleanInput === '') {
			setRut(null);
			searchParams.delete('rut');
			searchParams.set('page', 1);
		} else {
			const formattedRut = formatRut(rut);
			setRut(formattedRut);
			searchParams.set('rut', formattedRut);
			searchParams.set('page', 1);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};


	const handleSearchEmail = (email) => {
		const cleanEmail = email ? email.trim() : '';
		if (cleanEmail === '') {
			setEmail(null);
			searchParams.delete('email');
			searchParams.set('page', 1);
		} else {
			setEmail(cleanEmail);
			searchParams.set('email', cleanEmail);
			searchParams.set('page', 1);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleDownload = async () => {
    try {
      setIsDownloading(true);
      const response = await new Service().exportQuotations(token);
      if (response && response.url) {
        const link = document.createElement('a');
        link.href = response.url;
        link.setAttribute('download', response.filename || 'reporte-cotizaciones.xlsx'); 
        document.body.appendChild(link);
        link.click();
        
				document.body.removeChild(link);
      }

    } catch (error) {
      console.error('Error al descargar:', error);
    } finally {
      setIsDownloading(false);
    }
  };

	const handleTableChange = (pagination, filters, sorter) => {
    console.log("Evento Table Change:", sorter);

    const newOrder = sorter.order || null; 
    
    setSortOrder(newOrder);

    if (newOrder) {
        searchParams.set('sortOrder', newOrder === 'ascend' ? 'asc' : 'desc');
    } else {
        searchParams.delete('sortOrder');
    }
    history.push({
        pathname: location?.pathname,
        search: handleSearchParams(searchParams),
    });
  };

	const handleTabClick = (key) => {
		const tab = tabOptions(data).find((tab) => tab.key === key);
		if (tab) {
			setStatus(tab.status);
			handleStatusQueryChange(tab.status);
			onTabChange();
		}
		const filteredData = tabOptions(data).map((tab) => ({
			...tab,
			data: tab.data?.filter((item) => {
				return item;
			}),
		}));

		return filteredData;
	};

	const paginationConfig = {
		current: pagination.currentPage,
		pageSize: pagination.pageSize,
		total: pagination.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	const operations = (
		<div className="operations-container">
			<div className="search-input-group">
				<div className="own-order-search-container">
					<CustomSearch 
						placeholder={'N° de solicitud'} 
						onSearch={handleSearchCode} 
					/>
				</div>
				<div className="own-order-search-container">
					<CustomSearch 
						placeholder={'N° de RUT'} 
						onSearch={handleSearchRut} 
					/>
				</div>
				<div className="own-order-search-container">
					<CustomSearch 
						placeholder={'e-mail'} 
						onSearch={handleSearchEmail} 
					/>
				</div>
			</div>
			<div className="download-button-container">
				<CustomButton 
					type="primary" 
					icon={<DownloadOutlined />}
					onClick={handleDownload}
					className="download-button"
					loading={isDownloading}
          disabled={isDownloading}
				>
					{isDownloading ? 'Descargando...' : 'Descargar'}
				</CustomButton>
			</div>
		</div>
	);

	const initialActiveTab = tabOptions(data).find((tab) => tab.status === status)?.key;


	const itemsDropdownStatus = [
		{
			key: 'all',
			label: statusPreparation[Enviroment.LANGUAGE]['all'],
			value: 'null',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '001',
			label: statusPreparation[Enviroment.LANGUAGE]['001'],
			value: '001',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '002',
			label: statusPreparation[Enviroment.LANGUAGE]['002'],
			value: '002',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '003',
			label: statusPreparation[Enviroment.LANGUAGE]['003'],
			value: '003',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '101',
			label: statusPreparation[Enviroment.LANGUAGE]['101'],
			value: '101',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '201',
			label: statusPreparation[Enviroment.LANGUAGE]['201'],
			value: '201',
			onClick: (e) => handleDropdownSelect(e.key),
		},
	];

	if (isLoading) {
		return <Loading />;
	}
	if (isLoading === false) {
		return (
			<div className="tracking-orders-list-container">
				<Row>
					<Col span={8}>
						<h2>Cotizaciones</h2>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Col className={'own-order-main-container'}>
							<CustomTabs tabBarExtraContent={operations} onChange={handleTabClick} activeKey={initialActiveTab}>
								{handleTabClick().map((tab) => (
									<CustomTabs key={tab.key} tab={tab.tab}>
										<CustomTable
										onChange={handleTableChange}
											dataSource={tab.data}
											columns={generateColumns(itemsDropdownStatus, status, sortOrder)}
											pagination={paginationConfig}
											rowKey={rowKey}
											loading={isTableLoading}
										/>
									</CustomTabs>
								))}
							</CustomTabs>
						</Col>
					</Col>
				</Row>
			</div>
		);
	}
}
